/*
 * Jira Ticket:
 * Created Date: Tue, 14th Apr 2020, 10:00:12 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Dialog,
  IconButton,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { modalStyles } from 'styles';

const DialogTitle = props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const ErrorModal = ({
  dialogCopy,
  dialogOpen,
  dialogTitle,
  setDialogState,
}) => {
  const classes = modalStyles();
  return (
    <div>
      <Dialog
        onClose={() => setDialogState(false)}
        aria-labelledby="customized-dialog-title"
        open={dialogOpen}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setDialogState(false)}
          classes={classes}
        >
          <strong>{dialogTitle}</strong>
        </DialogTitle>
        <MuiDialogContent className={classes.content} dividers>
          <div>{dialogCopy}</div>
        </MuiDialogContent>
      </Dialog>
    </div>
  );
};

export default ErrorModal;
